import { render, staticRenderFns } from "./MainModeSwitch.vue?vue&type=template&id=8c4c990a&scoped=true"
import script from "./MainModeSwitch.vue?vue&type=script&lang=ts"
export * from "./MainModeSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4c990a",
  null
  
)

export default component.exports